"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = interpret;
exports.continueProcessingSubRulesGivenValue = continueProcessingSubRulesGivenValue;
exports.buildRepeatRule = buildRepeatRule;
exports.buildIfRepeatRule = buildIfRepeatRule;
exports.buildExceptionRepeatRule = buildExceptionRepeatRule;
exports.buildOnlyRule = buildOnlyRule;
exports.buildBetweenRule = buildBetweenRule;
exports.buildUntilRule = buildUntilRule;
exports.isTruthyDate = isTruthyDate;
exports.buildModifyRepeatRule = buildModifyRepeatRule;
exports.buildRawModifyRepeatRule = buildRawModifyRepeatRule;
exports.buildParentSameEventRule = buildParentSameEventRule;
exports.buildSameAsExceptionRule = buildSameAsExceptionRule;
exports.buildParentRepeatRule = buildParentRepeatRule;
exports.sortByNextDate = sortByNextDate;
exports.getNextDate = getNextDate;
exports.buildAnyOfSubRuleSelector = buildAnyOfSubRuleSelector;
exports.buildAllOfSubRuleSelector = buildAllOfSubRuleSelector;
exports.combineRepeatRules = combineRepeatRules;
exports.getRuleBuilderForRule = exports.NEVER_RULE = exports.FINAL_REPEAT_RULE_STRING = exports.FINAL_REPEAT_RULE = void 0;

var _addDays = _interopRequireDefault(require("date-fns/addDays"));

var _addBusinessDays = _interopRequireDefault(require("date-fns/addBusinessDays"));

var _addMonths = _interopRequireDefault(require("date-fns/addMonths"));

var _addWeeks = _interopRequireDefault(require("date-fns/addWeeks"));

var _addQuarters = _interopRequireDefault(require("date-fns/addQuarters"));

var _addYears = _interopRequireDefault(require("date-fns/addYears"));

var _isLastDayOfMonth = _interopRequireDefault(require("date-fns/isLastDayOfMonth"));

var _lastDayOfMonth = _interopRequireDefault(require("date-fns/lastDayOfMonth"));

var _getDaysInMonth = _interopRequireDefault(require("date-fns/getDaysInMonth"));

var _startOfMonth = _interopRequireDefault(require("date-fns/startOfMonth"));

var _getWeekOfMonth = _interopRequireDefault(require("date-fns/getWeekOfMonth"));

var _getDay = _interopRequireDefault(require("date-fns/getDay"));

var _getDate = _interopRequireDefault(require("date-fns/getDate"));

var _set = _interopRequireDefault(require("date-fns/set"));

var _startOfDay = _interopRequireDefault(require("date-fns/startOfDay"));

var _isWeekend = _interopRequireDefault(require("date-fns/isWeekend"));

var _getMonth = _interopRequireDefault(require("date-fns/getMonth"));

var _getYear = _interopRequireDefault(require("date-fns/getYear"));

var _isBefore = _interopRequireDefault(require("date-fns/isBefore"));

var _isWithinInterval = _interopRequireDefault(require("date-fns/isWithinInterval"));

var _isEqual = _interopRequireDefault(require("date-fns/isEqual"));

var _isAfter = _interopRequireDefault(require("date-fns/isAfter"));

var _compareAsc = _interopRequireDefault(require("date-fns/compareAsc"));

var _getUnixTime = _interopRequireDefault(require("date-fns/getUnixTime"));

var _isFriday = _interopRequireDefault(require("date-fns/isFriday"));

var _date = require("../../utils/date");

var _atom = require("../../utils/atom");

var FINAL_REPEAT_RULE = (0, _set.default)((0, _startOfDay.default)(new Date()), {
  year: 9999,
  month: 11,
  date: 31
});
exports.FINAL_REPEAT_RULE = FINAL_REPEAT_RULE;
var FINAL_REPEAT_RULE_STRING = (0, _date.formatDate)(FINAL_REPEAT_RULE);
exports.FINAL_REPEAT_RULE_STRING = FINAL_REPEAT_RULE_STRING;
var ESCAPE_REPEAT_RULE = (0, _addYears.default)((0, _startOfDay.default)(new Date()), 100);

var NEVER_RULE = function NEVER_RULE() {
  return FINAL_REPEAT_RULE;
};

exports.NEVER_RULE = NEVER_RULE;

var MIRROR_FUNC = function MIRROR_FUNC(val) {
  return val;
};

var SKIP = "skip";

function interpret() {
  var rules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (!rules.length) {
    return NEVER_RULE;
  }

  return combineRepeatRules(rules.map(function (rule) {
    return buildRepeatRule(rule);
  }));
}

var ruleBuilderDispatch = {
  startingChoice: {
    startingOn: buildParentRepeatRule,
    sameAs: buildParentSameEventRule
  },
  exception: {
    except: buildExceptionRepeatRule,
    if: buildIfRepeatRule,
    modify: buildModifyRepeatRule,
    only: buildOnlyRule,
    until: buildUntilRule,
    between: buildBetweenRule,
    anyOf: buildAnyOfSubRuleSelector,
    allOf: buildAllOfSubRuleSelector
  },
  modifySubRule: {
    except: buildExceptionRepeatRule,
    if: buildIfRepeatRule,
    only: buildOnlyRule,
    until: buildUntilRule,
    between: buildBetweenRule,
    anyOf: buildAnyOfSubRuleSelector,
    allOf: buildAllOfSubRuleSelector
  }
};
var getRuleBuilderForRule = (0, _atom.makeRuleBuilder)(ruleBuilderDispatch);
exports.getRuleBuilderForRule = getRuleBuilderForRule;

function repeatRulePostProcessor(ruleFunc, isSubRule) {
  if (isSubRule) {
    return ruleFunc;
  } else {
    var neverRepeats = false;
    return function (obj) {
      if (neverRepeats) {
        return FINAL_REPEAT_RULE;
      }

      var res = null;

      do {
        res = ruleFunc(obj);

        if (res !== SKIP && (0, _isAfter.default)(res, ESCAPE_REPEAT_RULE)) {
          neverRepeats = true;
          return FINAL_REPEAT_RULE;
        }
      } while (res === SKIP);

      return res;
    };
  }
} // if we get a SKIP value, then we stop processing and bail out.


function continueProcessingSubRulesGivenValue(value) {
  return value !== SKIP;
}

function buildRepeatRule(rule) {
  return (0, _atom.buildRule)(getRuleBuilderForRule, rule, {
    continueProcessingSubRules: continueProcessingSubRulesGivenValue,
    postProcessor: repeatRulePostProcessor
  });
}

function buildIfRepeatRule(valueFinder) {
  var exceptionRule = buildExceptionRepeatRule(valueFinder);
  return function (value, obj) {
    if ((0, _isAfter.default)(value, ESCAPE_REPEAT_RULE)) {
      return FINAL_REPEAT_RULE;
    }

    var exceptionValue = exceptionRule(value, obj);
    return exceptionValue === SKIP ? value : SKIP;
  };
}

function buildExceptionRepeatRule(valueFinder) {
  var exceptSelector = valueFinder("exceptSelector");

  switch (exceptSelector) {
    case "date":
      {
        var exceptOnDate = (0, _date.parseDateString)(valueFinder("exceptOnDate"));
        return function (value) {
          return (0, _isEqual.default)(value, exceptOnDate) ? SKIP : value;
        };
      }

    case "day":
      {
        var exceptOnDay = valueFinder("exceptOnDay");
        return function (value) {
          return _date.weekdays[(0, _getDay.default)(value)] === exceptOnDay ? SKIP : value;
        };
      }

    case "in":
      {
        var exceptInSelector = valueFinder("exceptInSelector");

        switch (exceptInSelector) {
          case "month":
            {
              var exceptInMonth = valueFinder("exceptInMonth");
              return function (value) {
                return _date.months[(0, _getMonth.default)(value)] === exceptInMonth ? SKIP : value;
              };
            }

          case "year":
            {
              var exceptInYear = valueFinder("exceptInYear");
              return function (value) {
                return (0, _getYear.default)(value) === exceptInYear ? SKIP : value;
              };
            }

          default:
            return MIRROR_FUNC;
        }
      }

    case "sameAs":
      {
        var sameAsSelector = valueFinder("sameAsSelector"); // create a fake sameAsRule.

        var sameAsRule = buildRepeatRule({
          values: [{
            idx: 0,
            id: "startingChoice",
            value: "sameAs"
          }, {
            idx: 1,
            id: "sameAsSelector",
            value: sameAsSelector
          }],
          subRules: []
        });
        return buildSameAsExceptionRule(sameAsRule);
      }

    default:
      return MIRROR_FUNC;
  }
}

function buildOnlyRule(valueFinder) {
  var onlyMagnitude = valueFinder("onlyMagnitude");
  var numCalls = 0;
  return function (value) {
    if (numCalls++ < onlyMagnitude) {
      return value;
    }

    return FINAL_REPEAT_RULE;
  };
}

function buildBetweenRule(valueFinder) {
  var start = (0, _date.parseDateString)(valueFinder("betweenStartDate"));
  var end = (0, _date.parseDateString)(valueFinder("betweenEndDate")); // if it's an invalid interval and the end comes first, then just return the value.

  if ((0, _isBefore.default)(end, start)) {
    return MIRROR_FUNC;
  }

  var interval = {
    start: start,
    end: end
  };
  return function (value) {
    if ((0, _isAfter.default)(value, end)) {
      return FINAL_REPEAT_RULE;
    } else {
      return (0, _isWithinInterval.default)(value, interval) ? value : SKIP;
    }
  };
}

function buildUntilRule(valueFinder) {
  var untilDate = (0, _date.parseDateString)(valueFinder("untilDate"));
  return function (value) {
    return (0, _isAfter.default)(value, untilDate) ? FINAL_REPEAT_RULE : value;
  };
}

function isTruthyDate(date) {
  return date !== SKIP && date !== FINAL_REPEAT_RULE;
}

function buildModifyRepeatRule(valueFinder) {
  var modifyRule = buildRawModifyRepeatRule(valueFinder);
  return function (val, obj) {
    var subRules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var modifiedVal = modifyRule(val);
    var shouldModify = subRules.reduce(function (shouldModify, subRule) {
      return shouldModify && isTruthyDate(subRule(val, obj, subRules));
    }, true);
    return shouldModify ? modifiedVal : val;
  };
}

function buildRawModifyRepeatRule(valueFinder) {
  var onModify = valueFinder("onModify");

  switch (onModify) {
    case "nothing":
      {
        return MIRROR_FUNC;
      }

    case "previous-weekday":
      {
        return function (val) {
          if ((0, _isWeekend.default)(val)) {
            var day = (0, _getDay.default)(val);
            var delta = day === 0 ? -2 : -1;
            return (0, _addDays.default)(val, delta);
          } else {
            return val;
          }
        };
      }

    case "next-weekday":
      {
        return function (val) {
          if ((0, _isWeekend.default)(val)) {
            var day = (0, _getDay.default)(val);
            var delta = day === 0 ? 1 : 2;
            return (0, _addDays.default)(val, delta);
          } else {
            return val;
          }
        };
      }

    case "closest-weekday":
      {
        return _date.getClosestWeekday;
      }

    case "closest-weekday-this-month":
      {
        return function (val) {
          var closestWeekday = (0, _date.getClosestWeekday)(val); // if it's in the same month, we're golden.

          if ((0, _getMonth.default)(closestWeekday) === (0, _getMonth.default)(val)) {
            return closestWeekday;
          } // otherwise, if we're on a Friday we need to advance 3 days
          // and if we're on a Monday, we need to back up 3 days
          else {
              return (0, _addDays.default)(closestWeekday, (0, _isFriday.default)(closestWeekday) ? 3 : -3);
            }
        };
      }

    case "offset":
      {
        var offsetMagnitude = valueFinder("offsetMagnitude");
        var units = valueFinder("offsetRepeatSelector");
        var offsetFunc = {
          days: _addDays.default,
          "business days": _addBusinessDays.default,
          weeks: _addWeeks.default,
          months: _addMonths.default,
          quarters: _addQuarters.default,
          years: _addYears.default
        };
        return function (val) {
          return offsetFunc[units](val, offsetMagnitude);
        };
      }

    case "moving":
      {
        var movingSelector = valueFinder("movingSelector");

        var onWeekSelector = _date.weekdays.findIndex(function (day) {
          return day === valueFinder("onWeekSelector");
        });

        var movingOffset = movingSelector === "next" ? 0 : -7;
        return function (val) {
          var day = (0, _getDay.default)(val); // already on that day? Then we're good.

          if (day === onWeekSelector) {
            return val;
          }

          var delta = movingOffset + (day < onWeekSelector ? onWeekSelector - day : 7 - (day - onWeekSelector));
          return (0, _addDays.default)(val, delta);
        };
      }

    default:
      {
        return MIRROR_FUNC;
      }
  }
}

function buildParentSameEventRule(valueFinder) {
  var eventId = valueFinder("sameAsSelector");
  var eventRepeatRule;
  return function (state) {
    if (!eventRepeatRule) {
      var evt = state.events[eventId];

      if (evt && evt.repeatRules) {
        eventRepeatRule = interpret(evt.repeatRules);
      } else {
        eventRepeatRule = NEVER_RULE;
      }
    }

    return eventRepeatRule(state);
  };
}

function buildSameAsExceptionRule(sameAsRule) {
  var exceptionDate;
  return function (val, obj) {
    if (exceptionDate === undefined) {
      exceptionDate = sameAsRule(obj);
    }

    while ((0, _isBefore.default)(exceptionDate, val)) {
      exceptionDate = sameAsRule(obj);
    }

    if ((0, _isEqual.default)(val, exceptionDate)) {
      return SKIP;
    }

    return val;
  };
}

function buildParentRepeatRule(valueFinder) {
  var startDate = (0, _date.parseDateString)(valueFinder("startingOnSelector"));
  var andThen = valueFinder("andThenSelector");

  switch (andThen) {
    case "every":
      {
        var magnitude = valueFinder("magnitude");
        var repeater = valueFinder("repeatSelector");
        var iterator = 0;

        switch (repeater) {
          case "days":
            {
              return function () {
                return (0, _addDays.default)(startDate, magnitude * iterator++);
              };
            }

          case "business days":
            {
              return function () {
                return (0, _addBusinessDays.default)(startDate, magnitude * iterator++);
              };
            }

          case "weeks":
            {
              return function () {
                return (0, _addWeeks.default)(startDate, magnitude * iterator++);
              };
            }

          case "weekdays":
            {
              var targetDay = (0, _getDay.default)(startDate);
              var targetWeek = (0, _getWeekOfMonth.default)(startDate, {
                weekStartsOn: (0, _getDay.default)((0, _startOfMonth.default)(startDate))
              });
              return function () {
                var date = (0, _startOfMonth.default)((0, _addMonths.default)(startDate, magnitude * iterator++));
                return (0, _date.getWeekDayFromStart)({
                  startOfMonth: date,
                  targetDay: targetDay,
                  targetWeek: targetWeek
                });
              };
            }

          case "last weekdays":
            {
              var _targetDay = (0, _getDay.default)(startDate);

              var targetDate = (0, _getDate.default)(startDate);

              var _targetWeek = (0, _getWeekOfMonth.default)(startDate, {
                weekStartsOn: (0, _getDay.default)((0, _startOfMonth.default)(startDate))
              });

              var targetDaysInMonth = (0, _getDaysInMonth.default)(startDate);
              var targetWeekNum = Math.floor((targetDaysInMonth - targetDate) / 7);
              return function () {
                var date = (0, _startOfMonth.default)((0, _addMonths.default)(startDate, magnitude * iterator++));
                return (0, _date.getWeekDayFromEnd)({
                  startOfMonth: date,
                  targetDay: _targetDay,
                  targetWeek: _targetWeek,
                  targetWeekNum: targetWeekNum
                });
              };
            }

          case "months":
            {
              if ((0, _isLastDayOfMonth.default)(startDate)) {
                return function () {
                  return (0, _lastDayOfMonth.default)((0, _addMonths.default)(startDate, magnitude * iterator++));
                };
              } else {
                return function () {
                  return (0, _addMonths.default)(startDate, magnitude * iterator++);
                };
              }
            }

          case "quarters":
            {
              return function () {
                return (0, _addQuarters.default)(startDate, magnitude * iterator++);
              };
            }

          case "years":
            {
              return function () {
                return (0, _addYears.default)(startDate, magnitude * iterator++);
              };
            }

          case "weekday years":
            {
              var _targetDay2 = (0, _getDay.default)(startDate);

              var _targetWeek2 = (0, _getWeekOfMonth.default)(startDate, {
                weekStartsOn: (0, _getDay.default)((0, _startOfMonth.default)(startDate))
              });

              return function () {
                var date = (0, _startOfMonth.default)((0, _addYears.default)(startDate, magnitude * iterator++));
                return (0, _date.getWeekDayFromStart)({
                  startOfMonth: date,
                  targetDay: _targetDay2,
                  targetWeek: _targetWeek2
                });
              };
            }

          case "last weekday years":
            {
              var _targetDay3 = (0, _getDay.default)(startDate);

              var _targetDate = (0, _getDate.default)(startDate);

              var _targetWeek3 = (0, _getWeekOfMonth.default)(startDate, {
                weekStartsOn: (0, _getDay.default)((0, _startOfMonth.default)(startDate))
              });

              var _targetDaysInMonth = (0, _getDaysInMonth.default)(startDate);

              var _targetWeekNum = Math.floor((_targetDaysInMonth - _targetDate) / 7);

              return function () {
                var date = (0, _startOfMonth.default)((0, _addYears.default)(startDate, magnitude * iterator++));
                return (0, _date.getWeekDayFromEnd)({
                  startOfMonth: date,
                  targetDay: _targetDay3,
                  targetWeek: _targetWeek3,
                  targetWeekNum: _targetWeekNum
                });
              };
            }

          default:
            return NEVER_RULE;
        }
      }

    case "never":
      {
        var wasCalled = false;
        return function () {
          if (!wasCalled) {
            wasCalled = true;
            return startDate;
          } else {
            return FINAL_REPEAT_RULE;
          }
        };
      }

    default:
      return NEVER_RULE;
  }
}

function sortByNextDate(a, b) {
  return (0, _compareAsc.default)(a.nextDate, b.nextDate);
}

function getNextDate(repeatRule, obj) {
  var nextDate = repeatRule(obj);
  return {
    nextDate: nextDate,
    repeatRule: repeatRule
  };
}

function buildAnyOfSubRuleSelector(valueFinder) {
  return function (val, obj, subRules) {
    var anyValid = subRules.reduce(function (currentValid, subRuleFunc) {
      // any of them...so the new value is non-zero and we keep it, or it is zero, so we use the old one.
      return currentValid || isTruthyDate(subRuleFunc(val, obj));
    }, false);
    return anyValid ? val : SKIP;
  };
}

function buildAllOfSubRuleSelector(valueFinder) {
  return function (val, obj, subRules) {
    var allValid = subRules.reduce(function (currentValid, subRuleFunc) {
      // just continue the stream.
      return currentValid && isTruthyDate(subRuleFunc(val, obj));
    }, true);
    return allValid ? val : SKIP;
  };
}

function combineRepeatRules() {
  var repeatRules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  // okay, first thing we do is we peel out the first date and the repeatRule function
  // then we stuff those into an array sorted by the nextDate
  if (repeatRules.length === 0) {
    return NEVER_RULE;
  }

  var ruleDispatch = [];
  var initialized = false; // and we keep a set of all dates that we've seen.

  var seenDates = new Set();

  var combinedRepeatRules = function combinedRepeatRules(state) {
    if (!initialized) {
      repeatRules.forEach(function (repeatRule) {
        return ruleDispatch.push(getNextDate(repeatRule, state));
      });
      ruleDispatch.sort(sortByNextDate);
      initialized = true;
    }

    if (ruleDispatch.length === 0) {
      return FINAL_REPEAT_RULE;
    }

    var nextInQueue = ruleDispatch.shift();
    var unixTime = (0, _getUnixTime.default)(nextInQueue.nextDate);

    if (!(0, _isEqual.default)(nextInQueue.nextDate, FINAL_REPEAT_RULE)) {
      ruleDispatch.push(getNextDate(nextInQueue.repeatRule, state));
      ruleDispatch.sort(sortByNextDate);
    }

    if (seenDates.has(unixTime)) {
      return combinedRepeatRules(state);
    } else {
      seenDates.add(unixTime);
      return nextInQueue.nextDate;
    }
  };

  return combinedRepeatRules;
}